<!-- 選択肢設定モーダル -->
<template>
  <transition name="right">
    <div style="position: absolute; top: 0; right: 0; height: 100vh; width: 54%; min-width: 1025px; background: #FEFEFE; padding: 16px; z-index: 201; overflow: scroll;" v-show="isSelectionOptionsModalOpen">
      <div class="modal-content">
        <h2 style="margin-bottom: 8px; font-weight: 600;">
          <span class="mdi mdi-format-list-checks" style="margin-right: 8px;"></span>選択肢設定 - {{ columnName }}
        </h2>
        <!-- 新しい選択肢の入力エリア -->
        <div style="display: flex; align-items: center; margin-bottom: 8px;">
          <input
            class="input is-small"
            v-model="newOption"
            placeholder="新しい選択肢"
            @keyup.enter="addOption"
            style="margin-left: 10px; width: calc(100% - 80px);"
          />
          <button
            @click="addOption"
            class="button is-small"
            style="width: 70px; margin-left: 10px;"
          >
            <span class="mdi mdi-plus" style="margin-right: 8px;"></span>追加
          </button>
        </div>
        <!-- 選択肢一覧テーブル -->
        <div class="table-container">
          <table v-if="tempPulldownColumnOptions.length > 0" style="width: 100%; min-width: 640px; table-layout: fixed;">
            <!-- テーブルヘッダー -->
            <thead>
              <tr style="display: table; width: 100%;">
                <th style="width: 60px;">移動</th>
                <th style="width: 60px;">順番</th>
                <th style="width: 550px;">選択肢</th>
                <th style="width: 60px;">削除</th>
              </tr>
            </thead>
            <!-- テーブルボディ -->
            <tbody>
              <draggable id="pulldown-list" :list="tempPulldownColumnOptions" @end="saveOptionOrder(tempPulldownColumnOptions)" :options="{animation: 300, handle: '.drag-button'}">
                <tr style="display: table; width: 100%;" v-for="(option, index) in tempPulldownColumnOptions" :key="option.id">
                  <td style="width: 60px; vertical-align: middle; padding: 0; overflow: hidden;">
                    <button class="drag-button trans-btn">
                      <span class="mdi mdi-drag mdi-24px"></span>
                    </button>
                  </td>
                  <td style="width: 60px; vertical-align: middle;">{{index + 1}}</td>
                  <td style="width: calc(100% - 180px); text-align: left; vertical-align: middle;">
                    <input class="input is-small" style="width: 100%; background: transparent;" v-model="option.name" @blur="updateOption(option)" />
                  </td>
                  <td style="width: 60px; text-align: center; vertical-align: middle;">
                    <button class="trans-btn" @click="deleteOption(option.id)">
                      <span class="mdi mdi-close"></span>
                    </button>
                  </td>
                </tr>
              </draggable>
            </tbody>
          </table>
        </div>
        <!-- ボタンエリア -->
        <div style="text-align: center;">
          <button class="button is-primary" @click="save">保存</button>
          <button class="button" @click="close" style="margin-left: 8px;">閉じる</button>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import draggable from 'vuedraggable'
import { mapState, mapActions } from 'vuex';

export default {
  components: {
    draggable,
  },
  data() {
    return {
      newOption: '',
      tempOptionName: '',
      isLoading: true,
    }
  },
  props: {
    // モーダルの開閉状態
    isSelectionOptionsModalOpen: Boolean,
    // 一時的な会社カラム設定
    tempCompanyColumnSetting: {
        type: Array,
        required: false,
        default: () => []
    },
    // 列ID
    columnId: {
      type: [Number, String],
      required: true,
    },
    // 列名
    columnName: {
      type: String,
      required: true,
    },
    // テーブル設定メニューの開閉状態
    isOpenTableSettingMenu: {
        type: Boolean,
        required: false,
        default: false
    }
  },
  computed: {
    ...mapState('auth', ['user','pulldownOptions']),
    // 選択肢オプション
    tempPulldownColumnOptions: {
      get() {
        return this.pulldownOptions[this.columnId] || [];
      },
      set(value) {
        this.$store.commit('auth/SET_PULLDOWN_OPTIONS', { columnId: this.columnId, tempPulldownColumnOptions: value });
      }
    }
  },
  watch: {
    // 列IDが変更されたら選択肢を取得
    columnId: {
      immediate: true,
      handler(newColumnId) {
        if (newColumnId) {
          this.loadOptions();
        }
      }
    },
    // モーダルが開いたら選択肢をロード
    isSelectionOptionsModalOpen(newVal) {
      if (newVal) {
        this.loadOptions();
      }
    },
  },

  methods: {
    ...mapActions('auth', ['createCompanyPulldownColumn', 'updateCompanyColumnSetting', 'updateCompanyPulldownColumn', 'deleteCompanyPulldownColumn', 'fetchCompanyPulldownColumns','updateCompanyPulldownOptions']),

    saveOptionOrder(tempPulldownColumnOptions) {
      tempPulldownColumnOptions.forEach((option, index) => {
        this.updateCompanyPulldownColumn({
          id: option.id,
          name: option.name,
          company: this.user.companyPK,
          companycolumnsetting: this.columnId,
          order: index
        });
      });
    },

    async loadOptions() {
      if (this.tempPulldownColumnOptions.length === 0) {
        this.isLoading = true;
        try {
          await this.fetchCompanyPulldownColumns({ columnId: this.columnId });
        } catch (error) {
          console.error('Failed to load tempPulldownColumnOptions:', error);
          this.openAlert('選択肢の読み込みに失敗しました');
        } finally {
          this.isLoading = false;
        }
      }
    },

    // 新しい選択肢を追加
    addOption() {
      if (this.newOption.trim() && !this.isDuplicatedOption(this.newOption)) {
        const newOptionData = {
          name: this.newOption,
          company: this.user.companyPK,
          companycolumnsetting: this.columnId,
          order: this.tempPulldownColumnOptions.length
        };

        if (!this.validateOptionData(newOptionData)) {
          this.openAlert('入力データが不正です。全ての項目を正しく入力してください。');
          return;
        }

        this.$store.dispatch('auth/createCompanyPulldownColumn', newOptionData)
          .then(responseData => {
            if (responseData && responseData.id) {
              const updatedOptions = [...this.tempPulldownColumnOptions, {
                id: responseData.id,
                name: responseData.name,
                order: responseData.order
              }];
              this.tempPulldownColumnOptions = updatedOptions; // This will trigger the setter
              this.newOption = '';
            } else {
              throw new Error('Invalid response format');
            }
          })
          .catch(error => {
            console.error('Error:', error);
            let errorMessage = '予期せぬエラーが発生しました';
            if (error.response) {
              console.error('Response data:', error.response.data);
            } else if (error.request) {
              console.error('No response received:', error.request);
              errorMessage = 'サーバーからの応答がありません';
            } else {
              console.error('Error message:', error.message);
              errorMessage = error.message;
            }
            this.openAlert(errorMessage);
          });
      } else if (this.isDuplicatedOption(this.newOption)) {
        this.openAlert('選択肢が重複しています');
      }
    },

    // 選択肢を削除
    deleteOption(id) {
      if (window.confirm('この選択肢を削除してもよろしいですか？')) {
        this.deleteCompanyPulldownColumn(id).then(() => {
          const updatedOptions = this.tempPulldownColumnOptions.filter(option => option.id !== id);
          this.tempPulldownColumnOptions = updatedOptions; // This will trigger the setter
        }).catch(error => {
          console.error('削除に失敗しました:', error);
          this.openAlert('削除に失敗しました');
        });
      }
    },

    // 選択肢データのバリデーション
    validateOptionData(data) {
      return data.name && data.company && data.companycolumnsetting !== undefined && data.order !== undefined;
    },

    // エラーメッセージのパース
    parseErrorMessage(errorData) {
      if (typeof errorData === 'string') {
        return errorData;
      }
      let message = 'エラーが発生しました：\n';
      for (let key in errorData) {
        if (Array.isArray(errorData[key])) {
          message += `${key}: ${errorData[key].join(', ')}\n`;
        } else {
          message += `${key}: ${errorData[key]}\n`;
        }
      }
      return message;
    },

// 選択肢を更新
    updateOption(option) {
      if (this.isDuplicatedOption(option.name)) {
        this.openAlert('選択肢が重複しています');
        option.name = this.tempOptionName;
      } else {
        this.updateCompanyPulldownColumn({
          id: option.id,
          name: option.name,
          company: this.user.companyPK,
          companycolumnsetting: this.columnId,
          order: option.order
        });
      }
    },
    // 変更を保存
    save() {
      // APIを呼び出して全ての変更を保存
      const updatedOptions = this.tempPulldownColumnOptions.map((option, index) => ({
        id: option.id,
        name: option.name,
        order: index
      }));
      this.updateCompanyPulldownOptions({
        columnId: this.columnId,
        options: updatedOptions
      });
      this.updateCompanyColumnSetting({
        company_id: this.user.companyPK,
        pk: this.columnId,  // 'column_id' の代わりに 'pk' を使用
        tempPulldownColumnOptions: updatedOptions
      });

      this.$emit('save', updatedOptions);
    },
    // モーダルを閉じる
    close() {
      this.$emit('close');
    },
    // 選択肢の重複チェック
    isDuplicatedOption(newVal) {
      return this.tempPulldownColumnOptions.some(option => option.text === newVal);
    },
    // アラートを表示
    openAlert(message) {
      this.$buefy.snackbar.open({
        message: message,
        type: 'is-warning',
        position: 'is-top',
        actionText: '閉じる',
        indefinite: true,
      });
    },
    // カラム順序を保存
    saveColumnOrder(temp) {
      this.$emit('save-column-order', temp);
    },
  },
  mounted() {
    if (this.isSelectionOptionsModalOpen) {
      this.loadOptions();
    }
  },
}
</script>
<style scoped lang="scss">
table td:not([align]), table th:not([align]) {
  text-align: center;
}
table {
  width: 100%;
  min-width: 1000px;
  border-collapse: collapse;
  margin: 0;
  height: calc(100vh - 200px);  // 固定の高さを設定（ヘッダーとボタンエリアの高さを考慮）
  overflow-y: auto;
  display: block;  // これを追加
}
table::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}
table::-webkit-scrollbar-thumb {
  background: #ccc;
  border-radius: 4px;
}
tr {
  width: 100%;
}
td,th {
  padding: 8px;
  margin: auto;
  font-size: smaller;
  border-style: solid;
  border-width: 1px;
  border-color: #AA0066;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
td {
  text-align: left;
  overflow: scroll;
  padding: 8px;
}
td > div::-webkit-scrollbar {
  width:  5px;
  height: 5px;
  visibility: hidden;
}
th {
  color:#fff;
  background:#AA0066;
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 10000;
}
table tr:nth-child(odd) {
  background:#ffeeff;
}
table tr:nth-child(even) {
  background:#fafafa;
}
.trans-btn {
  width: 100%;
  height: 35px;
  background: transparent;
  border: none;
  cursor: pointer;
}
.drag-button {
  width: 100%;
  height: 35px;
  background: transparent;
  border: none;
  cursor: move;
}
.input.is-small {
  width: 100%;
}
.modal-content {
  width: 100%;
  max-width: 100%;
}
.table-container {
  width: 100%;
  overflow-y: auto;
  height: calc(100vh - 200px);
}
</style>



// WEBPACK FOOTER //
// src/components/Manage/SelectionOptionsModal.vue